import React, { Component } from "react";
import "antd/dist/antd.css";
import { withRouter } from "react-router";
import { Form, Input, Row, Col, Button, Spin, message, Popover } from "antd";
import { Link } from "react-router-dom";
import AppConfigs from "../../Config/AppConfig";
import AwsConfig from "../../Config/AwsConfig";
import { getDetails, add, update } from "../../api/Apis";
import Amplify, { Auth } from "aws-amplify";
import { noWhitespaceRule, notValidPhoneNumberRule } from "../../utils/Utils";
Amplify.configure(AwsConfig);

const Password = {
  _pattern: /^[A-Za-z0-9_@./#&+-]*$/,
  _getRandomByte() {
    let result;
    if (window.crypto && window.crypto.getRandomValues) {
      result = new Uint8Array(1);
      window.crypto.getRandomValues(result);
      return result[0];
    } else if (window.msCrypto && window.msCrypto.getRandomValues) {
      result = new Uint8Array(1);
      window.msCrypto.getRandomValues(result);
      return result[0];
    } else {
      return Math.floor(Math.random() * 256);
    }
  },

  generate(length) {
    let i = 0;
    const password = [];
    while (i < length) {
      let characterValid = false;
      while (!characterValid) {
        const result = String.fromCharCode(this._getRandomByte());
        if (this._pattern.test(result)) {
          password.push(result);
          characterValid = true;
        }
      }
      i += 1;
    }
    return password.join("");
  },
};
class Driverform extends Component {
  constructor(props) {
    super(props);
    this.state = {
      formSubmitStatus: false,
      loading: false,
      formTitle: "Add A New Driver",
      buttonTitle: "Save",
      autoCompleteResult: [],
      latLng: {},
      selectedDriverAddress: "",
    };
  }

  componentDidMount() {
    this.setState({
      dataLoading: true,
    });
    if (this.props.match.params.id) {
      getDetails(
        AppConfigs["entityNames"]["users"],
        this.props.match.params.id
      ).then(async (result) => {
        if (result.success) {
          let driverData = result.data;
          this.setState({
            selectedDriverAddress: driverData["address"],
          });
          this.props.form.setFieldsValue({
            firstName: driverData["firstName"],
            lastName: driverData["lastName"],
            phone: driverData["phone"],
            email: driverData["email"],
            address: driverData["address"],
            // "city": driverData["city"],
            // "stateCode": driverData["stateCode"],
            // "zipcode": driverData["zipcode"]
          });
          this.setState({
            formTitle: "Edit Driver Details",
            buttonTitle: "Update",
            dataLoading: false,
          });
        } else {
          console.log(result.errors);
          this.setState({
            dataLoading: false,
          });
        }
      });
    } else {
      this.setState({
        dataLoading: false,
      });
    }
  }

  hasErrors = (fieldsError) =>
    Object.keys(fieldsError).some((field) => fieldsError[field]);
  handleSubmit = (e) => {
    e.preventDefault();
    this.props.form.validateFieldsAndScroll(async (err, values) => {
      if (!err) {
        // const orgDetails = JSON.parse(localStorage.getItem("orgDetails"));
        let data = {
          entityData: {
            firstName: values["firstName"],
            lastName: values["lastName"],
            email: values["email"],
            phone: values["phone"],
          },
        };
        if (this.props.match.params.id) {
          this.setState({
            formSubmitStatus: true,
          });
          update(
            AppConfigs["entityNames"]["users"],
            this.props.match.params.id,
            data
          ).then((result) => {
            if (result.success) {
              message.success(`Driver details updated successfully.`);
              this.props.history.push("/carrier_app/drivers");
            } else {
              message.error(result.errors.message.message);
              this.setState({
                formSubmitStatus: false,
              });
            }
          });
        } else {
          let userName = data["entityData"]["email"];
          let validPhone =
            data["entityData"]["phone"].length >= 10 ? true : false;
          // const regex = /^(?=.*[0-9])(?=.*[!@#$%^&*])[a-zA-Z0-9!@#$%^&*]{8,}$/;
          // let password = Password.generate(8);
          // while (!regex.test(password)) {
          //   password = Password.generate(8);
          // }
          if (validPhone) {
            this.setState({
              formSubmitStatus: true,
            });
            const password = values["password"];
            await Auth.signUp({
              username: userName,
              password: password,
            })
              .then((cognitoData) => {
                data["entityData"]["id"] = cognitoData.userSub;
                data["entityData"]["userProfile"] = "D";
                data["entityData"]["latLng"] = this.state.latLng;
                data["entityData"]["recordStatus"] = true;
                let userDetails = JSON.parse(
                  localStorage.getItem("userDetails")
                );
                data["entityData"]["orgId"] = userDetails.carrierDetails.id;
                add(AppConfigs["entityNames"]["users"], data).then((result) => {
                  if (result.success) {
                    message.success(`Driver created successfully.`);
                    this.props.history.push("/carrier_app/drivers");
                  } else {
                    message.error(result.errors.message.message);
                    this.setState({
                      formSubmitStatus: false,
                    });
                  }
                });
              })
              .catch((e) => {
                message.error(e.message);
                this.setState({
                  formSubmitStatus: false,
                });
              });
          } else {
            message.error("Please enter valid phone number");
          }
        }
      }
    });
  };

  handleConfirmBlur = (e) => {
    const { value } = e.target;
    this.setState({ confirmDirty: this.state.confirmDirty || !!value });
  };
  compareToFirstPassword = (rule, value, callback) => {
    const { form } = this.props;
    if (value && value !== form.getFieldValue("password")) {
      callback("Two passwords that you enter is inconsistent!");
    } else {
      callback();
    }
  };
  validateToNextPassword = (rule, value, callback) => {
    const { form } = this.props;
    if (value && this.state.confirmDirty) {
      form.validateFields(["confirm"], { force: true });
    }
    callback();
  };
  getAddress = (address, latLng, fieldId) => {
    this.props.form.setFieldsValue({
      [fieldId]: address,
    });
    let latLangs = this.state.latLangs;
    this.setState({
      latLangs,
    });
  };

  render() {
    const { getFieldDecorator } = this.props.form;
    let passwordCriteria = (
      <div>
        <Row>
          <Col lg={24} md={24} sm={24} xs={24}>
            -Minimum password length: 6 <br />
            -Required at least one uppercase letter
            <br />
            -Required at least one lowercase letter
            <br />
            -Required at least one number
            <br />
            -Required at least one nonalphanumeric character
            <br />
          </Col>
        </Row>
      </div>
    );
    return (
      <div style={{ margin: "30px" }}>
        <Spin spinning={this.state.dataLoading}>
          <h1
            style={{
              fontSize: "24px",
              color: "#24405E",
              paddingBottom: "30px",
            }}
          >
            {this.state.formTitle}
          </h1>
          <div
            style={{
              backgroundColor: "white",
              width: "auto",
              marginLeft: "auto",
              marginRight: "auto",
              padding: "20px",
            }}
          >
            <h2 style={{ fontSize: "20px", paddingBottom: "20px" }}>
              Driver Details
            </h2>
            <Form onSubmit={this.handleSubmit}>
              <Row gutter={10}>
                <Col span={12}>
                  <Form.Item
                    className="Formitem"
                    label={
                      <span style={{ color: "#7B8190", fontSize: "14px" }}>
                        First Name
                      </span>
                    }
                  >
                    {getFieldDecorator("firstName", {
                      rules: [
                        {
                          required: true,
                          message: "Please input your First Name!",
                        },
                        noWhitespaceRule,
                      ],
                    })(<Input />)}
                  </Form.Item>
                </Col>
                <Col span={12}>
                  <Form.Item
                    className="Formitem"
                    label={
                      <span style={{ color: "#7B8190", fontSize: "14px" }}>
                        Last Name
                      </span>
                    }
                  >
                    {getFieldDecorator("lastName", {
                      rules: [
                        {
                          required: true,
                          message: "Please input your Last Name!",
                        },
                        noWhitespaceRule,
                      ],
                    })(<Input />)}
                  </Form.Item>
                </Col>
              </Row>
              <Row gutter={10}>
                <Col span={12}>
                  <Form.Item
                    className="Formitem"
                    label={
                      <span style={{ color: "#7B8190", fontSize: "14px" }}>
                        Phone
                      </span>
                    }
                  >
                    {getFieldDecorator("phone", {
                      rules: [
                        { message: "The input is not valid phone number!" },
                        {
                          required: true,
                          message: "Please input your phone number!",
                        },
                        noWhitespaceRule,
                        notValidPhoneNumberRule,
                      ],
                    })(<Input style={{ width: "100%" }} />)}
                  </Form.Item>
                </Col>
                <Col span={12}>
                  <Form.Item
                    className="Formitem"
                    label={
                      <span style={{ color: "#7B8190", fontSize: "14px" }}>
                        Email
                      </span>
                    }
                  >
                    {getFieldDecorator("email", {
                      rules: [
                        {
                          type: "email",
                          message: "The input is not valid E-mail!",
                        },
                        {
                          required: true,
                          message: "Please input your E-mail!",
                        },
                      ],
                    })(
                      <Input
                        disabled={this.props.match.params.id ? true : false}
                      />
                    )}
                  </Form.Item>
                </Col>
              </Row>
              {!this.props.match.params.id && (
                <Row gutter={10}>
                  <Col span={12}>
                    <Form.Item
                      className="Formitem"
                      label={<span className="label">Password</span>}
                    >
                      {getFieldDecorator("password", {
                        rules: [
                          {
                            required: true,
                            message: "Please input your password!",
                          },
                          { validator: this.validateToNextPassword },
                        ],
                      })(
                        <Input.Password
                          placeholder="*********"
                          autoComplete="new-password"
                        />
                      )}
                    </Form.Item>
                    <Popover
                      placement="top"
                      title={
                        <h2 style={{ textAlign: "center" }}>
                          Password Criteria
                        </h2>
                      }
                      content={passwordCriteria}
                      // visible={this.state.notificationVisible}
                      trigger="hover"
                      // onVisibleChange={this.notificationHandlechange}
                    >
                      <span style={{ color: "#20a8d8" }}>Criteria</span>
                      {/*{this.state.notificationsCount !== 0 && <Badge count={this.state.notificationsCount} style={{ backgroundColor: '#FF6C5E', bottom: "14px", right: "18px" }}></Badge>} */}
                    </Popover>
                  </Col>
                  <Col span={12}>
                    <Form.Item
                      className="Formitem"
                      label={<span className="label">Confirm Password</span>}
                    >
                      {getFieldDecorator("confirm", {
                        rules: [
                          {
                            required: true,
                            message: "Please confirm your password!",
                          },
                          { validator: this.compareToFirstPassword },
                        ],
                      })(
                        <Input.Password
                          placeholder="*********"
                          onBlur={this.handleConfirmBlur}
                        />
                      )}
                    </Form.Item>
                  </Col>
                </Row>
              )}
              <Row>
                {/* <Col span={24}>
                  <Form.Item className="Formitem"
                    label={<span style={{ color: '#7B8190', fontSize: '14px' }}>Address</span>}>
                    {getFieldDecorator('address', {
                      rules: [{ required: true, message: 'Please input your Address!' }],
                    })(<LocationAutocomplete getAddress={(address,latLng) => this.getAddress(address,latLng,'address')} editMode={true} address={this.state.selectedDriverAddress} setAddress={(address) => {this.setState({selectedDriverAddress: address})}}/>)}
                  </Form.Item>
                </Col> */}
                {/* <Col span={12}>
                  <Form.Item className="Formitem"
                    label={<span style={{ color: '#7B8190', fontSize: '14px' }}>City</span>}>
                    {getFieldDecorator('city', {
                      rules: [{ required: true, message: 'Please input your City!' }],
                    })(<Input />)}
                  </Form.Item>
                </Col> */}
              </Row>
              {/* <Row>
                <Col span={12}>
                  <Form.Item className="Formitem"
                    label={<span style={{ color: '#7B8190', fontSize: '14px' }}>State</span>} >
                    {getFieldDecorator('stateCode', {
                      rules: [{ required: true, message: 'Please input your State!' }],
                    })(<Input />)}
                  </Form.Item>
                </Col>
                <Col span={12}>
                  <Form.Item className="Formitem"
                    label={<span style={{ color: '#7B8190', fontSize: '14px' }}>Zip</span>}>
                    {getFieldDecorator('zipcode', {
                      rules: [{ required: true, message: 'Please input your Zip!' }],
                    })(<Input />)}
                  </Form.Item>
                </Col>
              </Row> */}
              <Row>
                <Form.Item style={{ float: "right", marginTop: "20px" }}>
                  <Button
                    type="primary"
                    style={{
                      backgroundColor: "#25559517",
                      color: "#255595",
                      marginRight: "30px",
                      padding: "0 20px 0 20px",
                      border: "none",
                    }}
                    onClick={() =>
                      this.props.history.push("/carrier_app/drivers")
                    }
                  >
                    Cancel
                  </Button>
                  <Button
                    type="primary"
                    htmlType="submit"
                    style={{
                      backgroundColor: "#255595",
                      color: "white",
                      marginRight: "30px",
                      padding: "0 20px 0 20px",
                    }}
                    loading={this.state.formSubmitStatus}
                  >
                    {this.state.buttonTitle}
                  </Button>
                </Form.Item>
              </Row>
            </Form>
          </div>
        </Spin>
      </div>
    );
  }
}
export default Form.create({ name: "driverform" })(withRouter(Driverform));
